// Header nav padding adjustment
document.addEventListener('DOMContentLoaded', function() {
  const headerNav = document.getElementById('header-desktop-nav');
  
  // Skip if element doesn't exist
  if (!headerNav) return;
  
  // Function to check nav height and add padding if needed
  function adjustHeaderPadding() {
    // Store original padding
    const originalPadding = headerNav.style.paddingBottom;
    
    // Temporarily remove padding to get true height
    headerNav.style.paddingBottom = '0';
    
    // Get the height without padding
    const contentHeight = headerNav.offsetHeight;
    
    // Check if content exceeds threshold and set padding accordingly
    if (contentHeight > 64) {
      headerNav.style.paddingBottom = '12px';
    } else {
      headerNav.style.paddingBottom = '0';
    }
  }
  
  // Run on initial load
  adjustHeaderPadding();
  
  // Run on window resize
  window.addEventListener('resize', adjustHeaderPadding);
}); 